export enum LoginType {
  None = "None",
  Applicant = "Applicant",
  Approver = "Approver",
  AuxPolice = "AuxPolice",
}
